export default __webpack_public_path__ + "static/media/increase_tendency.119a0a60.svg";